module.exports = __webpack_public_path__ + "img/fig11.17ed35bd.jpg";